var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bdc2d4;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.208,150.336a21.1,21.1,0,1,1-21.135-21.05A21.148,21.148,0,0,1,172.208,150.336ZM177.2,96.073H123.855a27.655,27.655,0,0,0-27.608,27.6v53.405A27.588,27.588,0,0,0,123.855,204.6H177.2a27.588,27.588,0,0,0,27.608-27.521v-53.4A27.655,27.655,0,0,0,177.2,96.073Zm-26.127,87.242a32.94,32.94,0,1,1,32.912-32.979A32.979,32.979,0,0,1,151.073,183.315Zm34.861-60.266a7.836,7.836,0,1,1,7.877-7.8A7.821,7.821,0,0,1,185.934,123.049Zm-35.407-86.54A114.023,114.023,0,1,0,264.548,150.492,114.046,114.046,0,0,0,150.527,36.509Zm66.837,140.569A40.2,40.2,0,0,1,177.2,217.229H123.855A40.2,40.2,0,0,1,83.69,177.078v-53.4a40.2,40.2,0,0,1,40.165-40.152H177.2a40.2,40.2,0,0,1,40.164,40.152v53.405Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.f2b5d4b2b7f77e7ac2ca9c69b7749a05.svg";
export { ForwardRef as ReactComponent };